import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
import { BRAND_NAME, PHONE_DISPLAY, PHONE_TEL } from '../data/site';
import { MAIN_WHATSAPP_MESSAGE } from '../data/messages';
import { WhatsAppButton } from './WhatsAppButton';
import { trackPhoneClick } from '../utils/analytics';
export function SiteHeader() {
  return <header className="sticky top-0 z-40 border-b border-navy-700/60 bg-navy-900/95 backdrop-blur" data-id="element-262" data-mp="1ipwj6d075ig4">
      <div className="mx-auto flex max-w-content items-center justify-between gap-3 px-4 py-2.5 sm:px-6 sm:py-3" data-id="element-263" data-mp="v0bowxyleyrj">
        <Link to="/" className="flex items-center gap-2.5" data-id="element-264" data-mp="14wf0eufc49r5">
          <span className="flex h-9 w-9 items-center justify-center rounded bg-accent-500 font-display text-base font-bold text-white" data-id="element-265" data-mp="14xzw4nddxyql">
            OA
          </span>
          <span className="leading-tight" data-id="element-266" data-mp="2gaskrpavq72f">
            <span className="block font-display text-lg font-bold tracking-wide text-white" data-id="element-267" data-mp="2g9qyeooexy5e">{BRAND_NAME}</span>
            <span className="hidden text-xs text-steel-400 sm:block" data-id="element-268" data-mp="2belf7xmeaxl0">Bovedilla, casetón y vigueta · Bajío</span>
          </span>
        </Link>

        <div className="flex items-center gap-3" data-id="element-269" data-mp="2ei3vx8dxpz9m">
          <a href={`tel:${PHONE_TEL}`} onClick={() => trackPhoneClick('header')} aria-label={`Llamar al ${PHONE_DISPLAY}`} className="inline-flex items-center gap-2 text-sm font-medium text-steel-200 transition-colors duration-150 ease-out hover:text-white" data-id="element-270" data-mp="2ekzrwr682dvf">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-271" data-mp="1vsf4vqd7f2zj" />
            <span className="hidden sm:inline" data-id="element-272" data-mp="1vsxb9ftkyxl6">{PHONE_DISPLAY}</span>
          </a>
          <WhatsAppButton message={MAIN_WHATSAPP_MESSAGE} label="Cotizar por WhatsApp" location="header" className="hidden md:inline-flex" data-id="element-273" data-mp="20qqdxyvod9gp" />
        </div>
      </div>
    </header>;
}